import { createContext, useContext } from 'react'

/** True inside a `LabraChatDock`, which is the only place a sidebar has a column. */
export const LabraChatDockContext = createContext(false)

export const useHasChatDock = (): boolean => useContext(LabraChatDockContext)
